import React from 'react'
import { Analytics } from "@vercel/analytics/react"
import { Header, Footer } from "./LandingPage"
import { MapPin } from "lucide-react"
import SEO from './common/SEO'
import { getDestinations } from '../lib/destinations-data'
import type { Destination } from '../lib/destinations'
import { Link } from 'react-router-dom'

const DestinationsPage: React.FC = () => {
  const [items, setItems] = React.useState<Destination[]>([]);

  React.useEffect(() => {
    getDestinations().then(setItems).catch(err => console.error('Error loading destinations:', err));
  }, []);

  return (
    <div className="flex min-h-screen flex-col relative">
      <SEO path="/destinations" title="Dive destinations | Currents" description="Dive guides built from what the Currents community has logged and reviewed: real depths, conditions, and sightings." />
      <Header />
      <main className="flex-1 pt-24">
        <div className="container max-w-4xl py-8">
          <h1 className="text-4xl font-black tracking-tighter sm:text-5xl mb-3">Dive destinations</h1>
          <p className="text-lg text-muted-foreground mb-10">Guides built from what the Currents community has logged and reviewed. Real depths, conditions, and sightings.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {items.map(d => (
              <Link key={d.slug} to={`/destinations/${d.slug}`} className="group rounded-2xl border border-border bg-white p-6 shadow-sm hover:shadow-md transition-shadow">
                <h2 className="text-xl font-bold group-hover:text-[#1F80FF] transition-colors">{d.title}</h2>
                {d.region && (
                  <p className="mt-2 flex items-center text-sm text-muted-foreground">
                    <MapPin className="w-4 h-4 mr-1" />{d.region}
                  </p>
                )}
                <p className="mt-3 text-muted-foreground">{d.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <Analytics />
    </div>
  )
}

export default DestinationsPage
